/**
 * Temu「货品净重必填类目」（更新时间 2026-08-24）。
 * 叶子类目 catId / categoryId 命中时，发品 productSkuNetWeightReq 必填（value 单位 mg）。
 */

const RAW_IDS = `
11915,11843,11844,11994,12011,11918,11995,12009,12013,11920,12010,11921,12014,12001,12002,11846,11906,11907,11909,11910,11911,11912,11914,11872,11873,11860,11876,11958,11968,11881,11879,11882,11883,11969,11908,11913,29290,29291,29292,29293,30144,11856,11859,11861,11869,11877,11885,11886,11917,11922,11936,11944,11946,11947,11948,11949,11960,11971,11972,11973,11988,11992
`;

export const TEMU_NET_WEIGHT_REQUIRED_CATEGORY_IDS = Object.freeze(new Set(
  RAW_IDS
    .split(/[,\s]+/)
    .map((s) => String(s || '').trim())
    .filter(Boolean),
));

/**
 * @param {string|number|null|undefined} categoryId 叶子类目 ID
 * @returns {boolean}
 */
export function isTemuNetWeightRequiredForCategory(categoryId) {
  const id = String(categoryId ?? '').trim();
  if (!id) return false;
  return TEMU_NET_WEIGHT_REQUIRED_CATEGORY_IDS.has(id);
}
